import React from 'react'
import Todolist from './components/todousecontext/todo'
import Calculator from './components/Calculator/Calculator'


const App = () => {
  return (
    <>
    <Todolist/>
    </>
  )
}

export default App
